module.exports = __webpack_public_path__ + "static/media/female-vampire.27d5f882.svg";